<div class="row justify-content-center">
    <div class="col-md-12 web-delivery-requirements text-center">
        <h3 class="mt-3">Your requirements on test day</h3>
        <ul>
            <li>A desktop computer or laptop computer (you cannot use a phone, tablet, or Chromebook)</li>
            <li>Internet speed of at least 2Mb/s download speed, 1Mb/s upload speed</li>
            <li>A webcam, microphone, and speakers (wired headphones are allowed)</li>
            <li>Minimum screen resolution to be 1024x768 (dual monitors are not allowed)</li>
            <li>Do not adjust Ease of Access display settings</li>
            <li>Scaling set to 100%</li>
            <li>Mac OS 10.13 / Windows 8.1 or higher</li>
            <li>The identification document that you registered with</li>
            <li>Private, quiet room with a clear desk or table</li>
            <li>Only water in transparent container on your desk</li>
            <li>You can only take notes with the ProProctor Scratchpad on your test screen. You cannot use paper or electronic devices to take notes</li>
        </ul>
    </div>
</div>
